module.exports = __webpack_public_path__ + "img/idea.559714d8.svg";